import React, { useState } from 'react';
import PageHeader from "../../components/PageHeader";
import { useNavigate } from "react-router-dom";

import DataTable from "react-data-table-component";
import { deleteConfirmation } from "../../utils";
import { Button } from "react-bootstrap";
import AddCompanyModal from './Add';
import ViewModal from './View';
import useLiveDataTable from '../../hooks/useLiveDataTable';
import { useGetPermitsQuery, useRemovePermitMutation } from "../../redux/services/permitService";
import CustomPagination from "../../components/CustomPagination";
import moment from "moment/moment";


const PermitsPage = () => {
    const navigate = useNavigate()
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();

    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)

    const [removeRequest] = useRemovePermitMutation()

    const { data: data2, isFetching, refetch } = useGetPermitsQuery({
        pagination: `?page=${currentPage}&per_page=${perPage}&search_by=${searchBy}&search=${q}`
    })
    const permits = data2?.response?.data?.data
    const total = data2?.response?.data?.total;


    console.log('af', total)


    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }

    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleView = (items) => {
        setIsEdit(items)
        setIsView(true)
    }
    const data = [
        {
            title: 'Company A',
            link: 'https://google.com',
            description: 'lorem lipsum lorem lipsum lorem lipsum lorem lipsum ',
            created_at: '22-04-2025',
        },
    ];

    // const data = [];

    return (
        <>
            <PageHeader name="Permits & Reports" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0">
                                    <div className="col-auto p-0 d-flex">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={handleAdd}
                                        >
                                            Add Permits
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 d-flex ms-2">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => refetch()}
                                        >
                                            Refresh
                                        </Button>
                                    </div>
                                    {/*<div className="col-auto ms-auto">
                                        <button className="btn bg-light text-capitalize">
                                            Search By: <span className='text-success'>{searchBy?.split('_')?.join(' ')?.replace('full name', 'driver name')}</span>
                                        </button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                                value={searchQuery}
                                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                                onChange={(e) => setSearchQuery(e.target?.value)}
                                            />
                                            <span
                                                type="button"
                                                onClick={() => handleSearchChange(searchQuery)}
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                        </div>
                                    </div>*/}
                                </div>
                            </div>
                            <div className="card-body">
                                <CustomPagination
                                    isFetching={isFetching}
                                    data={permits}
                                    total={total}
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page

                                    columns={[
                                        {
                                            name: 'Title',
                                            selector: row => row.title,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('title')}
                                                >
                                                    {searchBy == 'company_name' ?
                                                        <b className='text-success'>Title</b> : 'Title'}
                                                </span>
                                            ),
                                        },
                                        {
                                            name: 'link',
                                            selector: row => row.link,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('link')}
                                                >
                                                    {searchBy == 'link' ?
                                                        <b className='text-success'>Link</b> : 'Link'}
                                                </span>
                                            ),
                                            cell: (row, i) => {
                                                return (
                                                    <>
                                                        <a href={row?.link || void (0)} target="_blank"
                                                            className="text-primary text-decoration-underline">
                                                            {row?.link?.substring(0, 25) || '-'}
                                                        </a>
                                                    </>
                                                )
                                            }
                                        },
                                        {
                                            name: 'Description',
                                            selector: row => row.description,
                                            cell: (row, i) => {
                                                return (
                                                    <>
                                                        {row.description?.substring(0, 25)}
                                                    </>
                                                )
                                            },
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('description')}
                                                >
                                                    {searchBy == 'email' ?
                                                        <b className='text-success'>Description</b> : 'Description'}
                                                </span>
                                            ),
                                        },
                                        {
                                            name: 'Created At',
                                            selector: row => row.created_at,
                                            sortable: true,
                                            cell: (row, i) => {
                                                return (
                                                    <>
                                                        {row?.created_at ? moment(row?.created_at)?.format('DD-MM-YYYY') : '-'}
                                                    </>
                                                )
                                            }
                                        },
                                        {
                                            name: 'Actions',
                                            cell: (row, i) => {
                                                return (
                                                    <div className="hstack gap-1 fs-1">

                                                        <a
                                                            aria-label="view"
                                                            onClick={handleView.bind(this, row)}
                                                            className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-eye-fill" />
                                                        </a>
                                                        <button
                                                            aria-label="edit"
                                                            onClick={handleEdit.bind(this, row)}
                                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-edit-line" />
                                                        </button>
                                                        <a
                                                            aria-label="delete"
                                                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light "
                                                        >
                                                            <i className="ri-delete-bin-7-line" />
                                                        </a>
                                                    </div>
                                                )
                                            },
                                            ignoreRowClick: true,
                                            allowOverflow: true,
                                            button: true,
                                            width: '150px'
                                        },
                                    ]}

                                />
                            </div>
                        </div>

                        {isShow && (
                            <AddCompanyModal
                                show={isShow}
                                handleClose={() => {
                                    setIsShow(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}

                        {isView && (
                            <ViewModal
                                show={isView}
                                handleClose={() => {
                                    setIsView(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};

export default PermitsPage;